import { render, staticRenderFns } from "./AddFeedbackModal.vue?vue&type=template&id=20e44106&scoped=true"
import script from "./AddFeedbackModal.vue?vue&type=script&lang=js"
export * from "./AddFeedbackModal.vue?vue&type=script&lang=js"
import style0 from "./AddFeedbackModal.vue?vue&type=style&index=0&id=20e44106&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20e44106",
  null
  
)

export default component.exports